import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import langIsEn from '../../utils/langIsEn';
import styles from './ContentDetail.css';

class ContentDetail extends Component {
  static propTypes = {
    engContent: PropTypes.string.isRequired,
    chtContent: PropTypes.string.isRequired,
    infos: PropTypes.object.isRequired,
  };

  breakToLines(text) {
    return text.split('\n').map((item, key) => {
      return (
        <span key={key}>
          {item}
          <br />
        </span>
      );
    });
  }

  renderKeyValue(key, value) {
    if (!value) {
      return null;
    }

    return (
      <p>
        <span className={styles.infoKey}>{key}:<br /></span>
        <span className={styles.infoValue}>{this.breakToLines(value)}</span>
      </p>
    );
  }

  renderInfos() {
    const { infos } = this.props;

    return (
      <div className="col--offset-1of12 col--3of12">
        {langIsEn() &&
          <div className={styles.engContentInfos}>
            {this.renderKeyValue('Scope', infos.engScope)}
            {this.renderKeyValue('Project Partner', infos.engPartner)}
            {this.renderKeyValue('Client', infos.engClient)}
          </div>
        }
        {!langIsEn() &&
          <div className={styles.contentInfos}>
            {this.renderKeyValue('Scope', infos.chtScope)}
            {this.renderKeyValue('Project Partner', infos.chtPartner)}
            {this.renderKeyValue('Client', infos.chtClient)}
          </div>
        }
      </div>
    );
  }

  render() {
    const { engContent, chtContent } = this.props;
    const langContent = langIsEn() ? engContent : chtContent;

    var contents = [];
    if (langContent != null) {
      contents = langContent.split("\n\n");
    }
    const contentsRows = [];
    contents.forEach((content, idx) => {
      contentsRows.push(<p key={idx}>{content}</p>);
    });

    return (
      <section className="container">
        <div className={classnames('row', styles.contentDetailContainer)}>
          <div className="col--8of12">
            <div className={classnames(
              styles.contentDetail,
              { [styles.chtContentDetail]: !langIsEn() }
            )}>
              {contentsRows}
            </div>
          </div>
          {this.renderInfos()}
        </div>
      </section>
    )
  }
}

export default ContentDetail;



// WEBPACK FOOTER //
// ./src/components/content-detail/ContentDetail.js